import { render, staticRenderFns } from "./PesquisarKanban.vue?vue&type=template&id=314f8f84&scoped=true"
import script from "./PesquisarKanban.vue?vue&type=script&lang=js"
export * from "./PesquisarKanban.vue?vue&type=script&lang=js"
import style0 from "./PesquisarKanban.vue?vue&type=style&index=0&id=314f8f84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314f8f84",
  null
  
)

export default component.exports